import className from 'classnames/bind';
import { LogosFragment } from '@graphqlTypes';
import { Image } from '@components';

import styles from './Logos.module.scss';
const cx = className.bind(styles);

type logo = LogosFragment['logos'][number];

export default function Logo  ({ logo }: logo) {
  if (!logo?.node) return null;
  return (
    <div className={cx("logo")}>
      <Image className={cx("logo__image")} image={logo} useTitleFallback />
    </div>
  );
};